<div class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/reports']">Reports</a> > Job Order Log</h3>
    </div>
  </div>
  <div class="form-card">
    <div class="row">
      <div class="col-sm-4 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Select Job No.</mat-label>
          <mat-select #jobRef (openedChange)="job.attachScroll(jobRef)" [(value)]="job.selectedId" required>
            <input class="select-input" placeholder="Search..." type="text" autocomplete="off" (keydown)="$event.stopPropagation()" (keyup)="job.onSearch($event)" matInput name="job_list">
            <mat-option *ngFor="let opt of job.items" [value]="opt.id">{{opt.job_no}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 mb-3">
        <button type="button" mat-flat-button color="primary" (click)="generateReport()">Generate Report</button>
      </div>
    </div>
  </div>
</div>

<div class="report-loading" *ngIf="speaker.isLoading && speaker.listData.length === 0">
  <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
  <span>Loading report...</span>
</div>

<app-report-list-container *ngIf="speaker.listData.length > 0"></app-report-list-container>